import React from "react";
import { Paragraph } from "../../components/paragraph/Paragraph";

const CustomParagraph = ({ text }) => {
  return (
    <Paragraph className="text-black-600 text-center font-semibold text-xl py-1 ">
      {text}
    </Paragraph>
  );
};

export default CustomParagraph;
